'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();

import { useEffect, useMemo, useRef, type ReactNode } from 'react'

export type EmailLinkProps = {
  user: string | string[]
  domain: string | string[]
  className?: string
  children?: ReactNode
  subject?: string
  target?: string
  rel?: string
  fallbackText?: string
}

const normalizePart = (value: string | string[]) => (Array.isArray(value) ? value.join('') : value)

export function EmailLink({
  user,
  domain,
  className,
  children,
  subject,
  target = '_blank',
  rel = 'noreferrer',
  fallbackText = '',
}: EmailLinkProps) {
  const linkRef = useRef<HTMLAnchorElement>(null)
  const normalizedUser = useMemo(() => normalizePart(user), [user])
  const normalizedDomain = useMemo(() => normalizePart(domain), [domain])
  const address = normalizedUser && normalizedDomain ? `${normalizedUser}@${normalizedDomain}` : ''

  useEffect(() => {
    const element = linkRef.current
    if (!element) {
      return
    }

    if (!address) {
      element.removeAttribute('href')
      element.setAttribute('aria-disabled', 'true')
      element.tabIndex = -1
      if (!children) {
        element.textContent = fallbackText
      }
      return
    }

    const mailtoHref = `mailto:${address}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`
    element.setAttribute('href', mailtoHref)
    element.setAttribute('aria-disabled', 'false')
    element.tabIndex = 0

    if (!children) {
      element.textContent = address
    }
  }, [address, children, fallbackText, subject])

  return (
    <a ref={linkRef} className={className} rel={rel} target={target} aria-disabled tabIndex={-1}>
      {children ?? fallbackText}
    </a>
  )
}
